import React, { createContext, useContext, useEffect, useState } from "react";

const ThemeContext = createContext(null);
export const useTheme = () => useContext(ThemeContext);

export function ThemeProvider({ children }) {
    const [theme, setTheme] = useState(() => localStorage.getItem("ares-theme") || "dark");

    useEffect(() => {
        const root = document.documentElement;
        if (theme === "light") root.classList.add("light");
        else root.classList.remove("light");
        localStorage.setItem("ares-theme", theme);
    }, [theme]);

    const toggle = () => setTheme((t) => (t === "dark" ? "light" : "dark"));

    return <ThemeContext.Provider value={{ theme, toggle }}>{children}</ThemeContext.Provider>;
}
